'use client'

import { create } from "zustand"

type CompleteAccountMandatoryField = {
    field: 'email' | 'password' | 'username'
    default?: string
}

type CompleteAccountOptionalField = {
    field: 'preferred_lang' | 'birthdate' | 'phone' | 'accept_newsletter',
    default?: string
}

type CompleteAccountAction = {
    action: 'email_not_confirmed'
}

export type CompleteAccountData = {
    missing_mandatory_fields?: (CompleteAccountMandatoryField | CompleteAccountOptionalField)[],
    missing_actions?: CompleteAccountAction[],
    missing_fields?: (CompleteAccountMandatoryField | CompleteAccountOptionalField)[]
}

interface CompleteAccountState {
  data: CompleteAccountData | null
  setData: (data: CompleteAccountData) => void,
  clearData: () => void
}

export const useCompleteAccountStore = create<CompleteAccountState>((set) => ({
    data: null,
    setData: (data: CompleteAccountData) => set({ data }),
    clearData: () => set({ data: null })
}))
